import { render } from "./BookmarkSearch.vue?vue&type=template&id=775884b8"
import script from "./BookmarkSearch.vue?vue&type=script&lang=js"
export * from "./BookmarkSearch.vue?vue&type=script&lang=js"

import "./BookmarkSearch.vue?vue&type=style&index=0&id=775884b8&lang=scss"

import exportComponent from "/usr/src/app/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__